import { render, staticRenderFns } from "./ChartJSBarChart.vue?vue&type=template&id=0743f84d&scoped=true"
import script from "./ChartJSBarChart.vue?vue&type=script&lang=js"
export * from "./ChartJSBarChart.vue?vue&type=script&lang=js"
import style0 from "./ChartJSBarChart.vue?vue&type=style&index=0&id=0743f84d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0743f84d",
  null
  
)

export default component.exports